import { useTranslation } from 'react-i18next';

export const ComplianceSection = () => {
  const { t } = useTranslation();

  return (
    <section className="pt-10 pb-12 lg:pt-16 lg:pb-24 bg-gray-50 border-t border-gray-100 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-1.5 h-full bg-brand-electric-blue/20"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">

          {/* Left Column: Intro */}
          <div className="lg:col-span-5 text-center lg:text-left animate-on-scroll">
            <div className="inline-block mb-6">
              <span className="font-audiowide text-sm tracking-widest text-brand-electric-blue uppercase">{t('compliance.badge')}</span>
            </div>
            <h2 className="font-audiowide text-3xl sm:text-4xl text-[#111111] leading-tight mb-6">
              {t('compliance.title').split('Reglada')[0]}
              <span className="lg:block"></span>
              {t('compliance.title').replace('Infraestructura de ', '')}
            </h2>
            <div className="w-16 h-1 bg-brand-electric-blue mx-auto lg:mx-0 rounded-full mb-8"></div>
            <p className="font-montserrat text-[#333333] leading-relaxed text-lg mb-8">
              {t('compliance.description')}
            </p>
            <a href="#contacto" className="inline-block px-8 py-4 rounded-lg bg-gradient-to-r from-brand-electric-blue to-brand-neon-green text-white font-montserrat font-semibold text-lg transition-transform hover:-translate-y-1 shadow-lg shadow-brand-neon-green/20">
              {t('compliance.cta')}
            </a>
          </div>

          {/* Right Column: Feature List */}
          <div className="lg:col-span-7 lg:pl-10">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-10">

              {/* Item 1 */}
              <div className="flex gap-4 items-start animate-on-scroll group">
                <div className="shrink-0 w-12 h-12 bg-white rounded-xl shadow-sm border border-gray-100 flex items-center justify-center group-hover:bg-brand-electric-blue/10 transition-colors">
                  <i className="fas fa-user-shield text-xl text-brand-electric-blue"></i>
                </div>
                <div>
                  <h3 className="font-audiowide text-lg text-[#111111] mb-2">{t('compliance.items.gdpr.title')}</h3>
                  <p className="font-montserrat text-[#555555] text-sm leading-relaxed">
                    {t('compliance.items.gdpr.text')}
                  </p>
                </div>
              </div>

              {/* Item 2 */}
              <div className="flex gap-4 items-start animate-on-scroll group" style={{ animationDelay: '0.1s' }}>
                <div className="shrink-0 w-12 h-12 bg-white rounded-xl shadow-sm border border-gray-100 flex items-center justify-center group-hover:bg-brand-electric-blue/10 transition-colors">
                  <i className="fas fa-fingerprint text-xl text-brand-electric-blue"></i>
                </div>
                <div>
                  <h3 className="font-audiowide text-lg text-[#111111] mb-2">{t('compliance.items.zeroTrust.title')}</h3>
                  <p className="font-montserrat text-[#555555] text-sm leading-relaxed">
                    {t('compliance.items.zeroTrust.text')}
                  </p>
                </div>
              </div>

              {/* Item 3 */}
              <div className="flex gap-4 items-start animate-on-scroll group" style={{ animationDelay: '0.2s' }}>
                <div className="shrink-0 w-12 h-12 bg-white rounded-xl shadow-sm border border-gray-100 flex items-center justify-center group-hover:bg-brand-electric-blue/10 transition-colors">
                  <i className="fas fa-file-signature text-xl text-brand-electric-blue"></i>
                </div>
                <div>
                  <h3 className="font-audiowide text-lg text-[#111111] mb-2">{t('compliance.items.smartContracts.title')}</h3>
                  <p className="font-montserrat text-[#555555] text-sm leading-relaxed">
                    {t('compliance.items.smartContracts.text')}
                  </p>
                </div>
              </div>

              {/* Item 4 */}
              <div className="flex gap-4 items-start animate-on-scroll group" style={{ animationDelay: '0.3s' }}>
                <div className="shrink-0 w-12 h-12 bg-white rounded-xl shadow-sm border border-gray-100 flex items-center justify-center group-hover:bg-brand-electric-blue/10 transition-colors">
                  <i className="fas fa-project-diagram text-xl text-brand-electric-blue"></i>
                </div>
                <div>
                  <h3 className="font-audiowide text-lg text-[#111111] mb-2">{t('compliance.items.api.title')}</h3>
                  <p className="font-montserrat text-[#555555] text-sm leading-relaxed">
                    {t('compliance.items.api.text')}
                  </p>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
};
